import React, { useRef, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { gsap } from 'gsap';
import './Statistics.scss';
import { statisticsData } from './statisticsData';

function Statistics() {
  const container = useRef();
  const barRef0 = useRef();
  const barRef1 = useRef();
  const barRef2 = useRef();
  const barRef3 = useRef();
  const allRefs = useRef();
  allRefs.current = [barRef0, barRef1, barRef2, barRef3];
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    allRefs.current.forEach((ref, i) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: 'top 75%',

          once: true,
          onEnter: () => {
            setShowCounter(true);
          }
        }
      });
      tl.to(`#${statisticsData[i][0].id}`, {
        width: `${statisticsData[i][0].number}%`,
        duration: 1.2
      }).to(
        `#${statisticsData[i][1].id}`,
        { width: `${statisticsData[i][1].number}%`, duration: 1.2 },
        '-=1.2'
      );
    });
  }, []);

  const SimpleHook = ({ index, number }) => {
    useCountUp({
      ref: `counter${index}`,
      end: number,
      start: 0,
      duration: 1.2
    });
    return <span id={`counter${index}`} />;
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphics" ref={container}>
        <h3>funding sources for down payments</h3>
        {statisticsData.map((data, i) => {
          return (
            <div className="statistics__graphics__sections">
              <div className="statistics__graphic__graph" ref={allRefs.current[i]}>
                <p className="statistics__graphic__graph__copy">{data[0].head}</p>
                <div className="bar">
                  <div className="bar-contents">
                    <div className="bar-left" id={data[0].id} />
                    <p className="bar-number">
                      {showCounter ? <SimpleHook index={`${i}-1`} number={data[0].number} /> : `0`}%
                    </p>
                  </div>
                </div>
              </div>

              <div className="statistics__graphic__graph">
                <p className="statistics__graphic__graph__copy">{data[1].head}</p>
                <div className="bar">
                  <div className="bar-contents">
                    <div className="bar-left" id={data[1].id} />
                    <p className="bar-number">
                      {showCounter ? <SimpleHook index={`${i}-2`} number={data[1].number} /> : `0`}%
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics;
